__turbopack_context__.v({
  "numericalRating": "SingleReviewHeader-module-scss-module__8eaD3q__numericalRating",
});
